<script setup lang="js">
import { computed, onMounted, ref, watch } from 'vue';

import { MODAL_SIDE } from '@/const';

import { useModalStore } from '@/stores/modal.store';
import ModalTemplate from '@/components/newModals/ModalTemplate.vue';

const props = defineProps({
  customVariable: { type: Object },
  variableTypeList: {
    type: Object,
    required: true,
  }
});

const modalStore = useModalStore();

const name = ref("");
const title = ref("");
const type = ref("");
const default_value = ref(null);

const hasDefaultValue = computed(() => {
  return ["double", "boolean", "date", "text"].includes(type.value || "");
});

function saveData() {
  modalStore.modalEmit('save', {
    name: name.value,
    title: title.value,
    type: type.value,
    default_value: default_value.value,
  });
}

function updateByProps(variable) {
  if (!variable) return;

  name.value = variable.name || '';
  title.value = variable.title || '';
  type.value = variable.type || '';
  default_value.value = variable.default_value;
}

watch(() => props.customVariable, (value) => updateByProps(value));

onMounted(() => updateByProps(props.customVariable));
</script>

<template>

  <ModalTemplate :variant="MODAL_SIDE" id="variable-modal">
    <template #title>
      <span v-if="props.customVariable">Редактировать переменную</span>
      <span v-else>Создать переменную</span>
    </template>

    <template #default>
      <div class="mt-3">
        <label class="form-label">Наименование</label>
        <input type="text" v-model="title" class="form-control" />
      </div>
      <div class="mt-3">
        <label class="form-label">Тип</label>
        <select v-model="type" :disabled="props.customVariable" class="form-select">
          <template v-for="typeKey in Object.keys(props.variableTypeList)" :key="typeKey">
            <option v-if="typeKey != 'array'" :value="typeKey">
              {{ props.variableTypeList[typeKey] }}
            </option>
          </template>
        </select>
      </div>
      <div class="mt-3" v-if="hasDefaultValue">
        <label class="form-label">Значение по умолчанию</label>
        <input type="date" v-model="default_value" class="form-control" v-if="type == 'date'" />
        <select v-model="default_value" class="form-select" v-else-if="type == 'boolean'">
          <option :value="true">Истина</option>
          <option :value="false">Ложь</option>
        </select>
        <input
          type="number"
          v-model="default_value"
          class="form-control"
          v-else-if="type == 'double'"
        />
        <input
          type="text"
          v-model="default_value"
          class="form-control"
          v-else-if="type == 'text'"
        />
      </div>
    </template>

    <template #footer="{ close }">
      <button class="btn-default btn-cancel" @click="close">Отмена</button>
      <button class="btn-default btn-primary" @click="saveData">Сохранить</button>
    </template>
  </ModalTemplate>
</template>
